// TICKET-9 🟡 Fichier sans aucun test (83 lignes, backup/restore complet)
// À créer : backup.test.ts — tester roundtrip export→validate→import, backup invalide
// Dépend de : TICKET-12 (consolidation legacy — les données legacy doivent être stables)

import { hubDb } from './db';

export interface BackupPayload {
  kind: 'indxone-full-backup';
  version: number;
  exportedAt: number;
  dexie: Record<string, unknown[]>;
  localStorage: Record<string, string>;
}

function collectLocalStorage(): Record<string, string> {
  const out: Record<string, string> = {};
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key && key.startsWith('indxone.')) {
      const val = localStorage.getItem(key);
      if (val) out[key] = val;
    }
  }
  return out;
}

async function collectDexie(): Promise<Record<string, unknown[]>> {
  const tables = [
    'prospects', 'missions', 'tasks', 'forms', 'formResponses',
    'devis', 'cras', 'missioInvoices', 'missionLeads',
    'missionMemories', 'proposals', 'clientRisks',
  ] as const;
  const out: Record<string, unknown[]> = {};
  for (const name of tables) {
    const table = (hubDb as any)[name];
    if (table) out[name] = await table.toArray();
  }
  return out;
}

export async function exportFullBackup(): Promise<BackupPayload> {
  const [dexie, localStorage] = await Promise.all([
    collectDexie(),
    collectLocalStorage(),
  ]);
  return {
    kind: 'indxone-full-backup',
    version: 1,
    exportedAt: Date.now(),
    dexie,
    localStorage,
  };
}

export function validateBackup(data: unknown): data is BackupPayload {
  if (!data || typeof data !== 'object') return false;
  const d = data as Record<string, unknown>;
  return (
    d.kind === 'indxone-full-backup' &&
    typeof d.version === 'number' &&
    typeof d.exportedAt === 'number' &&
    typeof d.dexie === 'object' &&
    d.dexie !== null &&
    typeof d.localStorage === 'object' &&
    d.localStorage !== null
  );
}

export async function importFullBackup(payload: BackupPayload): Promise<void> {
  // Clear existing Dexie data
  const dexieTables = Object.keys(payload.dexie);
  await hubDb.transaction('rw', dexieTables.map((t) => (hubDb as any)[t]).filter(Boolean), async () => {
    for (const name of dexieTables) {
      const table = (hubDb as any)[name];
      if (table) {
        await table.clear();
        const rows = payload.dexie[name];
        if (rows.length) await table.bulkAdd(rows);
      }
    }
  });

  // Restore localStorage keys
  for (const [key, val] of Object.entries(payload.localStorage)) {
    localStorage.setItem(key, val);
  }
}
